import { AtaChangelogOptions } from './ata-changlogs-schema.js';
export * from './ata-changlogs-schema.js';
export * from './changelogs-schema.js';
export const ChangelogOptions = {
    ATA: AtaChangelogOptions,
};
